import { render, staticRenderFns } from "./recruiterExample.vue?vue&type=template&id=d0a3bafe&scoped=true"
import script from "./recruiterExample.vue?vue&type=script&lang=js"
export * from "./recruiterExample.vue?vue&type=script&lang=js"
import style0 from "./recruiterExample.vue?vue&type=style&index=0&id=d0a3bafe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a3bafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0a3bafe')) {
      api.createRecord('d0a3bafe', component.options)
    } else {
      api.reload('d0a3bafe', component.options)
    }
    module.hot.accept("./recruiterExample.vue?vue&type=template&id=d0a3bafe&scoped=true", function () {
      api.rerender('d0a3bafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/optimization/recruiterExample.vue"
export default component.exports